import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './components/Home/HomePage';
import ProChatPage from './components/ProChat/ProChatPage';
import RegChatPage from './components/RegChat/RegChatPage';
import TeamPage from './components/Team/TeamPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/prochat" element={<ProChatPage />} />
          <Route path="/regchat" element={<RegChatPage />} />
          <Route path="/team" element={<TeamPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;